module.exports = __webpack_public_path__ + "img/y_2025.62b873ca.png";